import ComponentBase from "../../../public/component/component_base";

const { ccclass, property } = cc._decorator;

@ccclass
export default class PokerRecorderDetailItem extends ComponentBase{

    @property([cc.Node])
    nodeIconList: cc.Node[] = []

    get config(){
        return this.m_config
    }

    protected m_config: {point: number, name: string}

    setData(data){
        let colorCountList = data.colorCountList || []
        for (let index = 0; index < this.nodeIconList.length; index++) {
            const node = this.nodeIconList[index];
            let colorCount = colorCountList[index] || 0
            node.active = colorCount > 0
        }
    }

    setConfig(conf){
        this.m_config = conf
    }
}